import ipc from "../../../electron/ipc/ipc"
import { getIDB, setIDB, delIDB } from "../../../ext/indexedDB"

import moment from 'moment'
import { AJAX, BLOB, DLP, CHATS, CONTACTS, LOGIN } from '../../store/modulesNames'
import {
    ACT_ABORT_AJAX_CALL,
    ACT_AJAX_GET_FILE,
    ACT_SEND_FILE_SAVE_EVENT,
} from '../../store/actionsTypes'
import { DLP_SOURCE_TYPES } from '../../store/modules/dlp'
import {
    GET_AJAXX_CALL_IS_EXIST_BY_FILE,
    GET_AJAXX_CALL_PROGRESS_BY_FILE,
    GET_FILE_BLOB,
    GET_SELECTED_CHAT, 
    GET_MY_CONTACT, 
    GET_MERGED_CONTACT_BY_ID, 
    GET_IS_ROLES_SUPPORTED,
    GET_SERVER_API,
} from '../../store/gettersTypes'
import { mapGetters, mapActions } from 'vuex'

import Logger from '../../common/Logger'
const logger = new Logger('chat-message-mixin')

const mixin = {
    computed: {
        isAjaxCookiesSupported() {
            return this[GET_SERVER_API] >= declarations.serverAPILevels.LEVEL_17
        },
        xhrFile() { 
            let index = this.currentGroupIndex
            if (index > -1) {
                return this.message && this.message.groupMsgs[index] && this.message.groupMsgs[index].file
            } else return null
        },
        xhrId() { 
            return this.xhrFile && this[GET_AJAXX_CALL_IS_EXIST_BY_FILE](this.xhrFile) 
        },
        isPending() { return this[GET_AJAXX_CALL_IS_EXIST_BY_FILE](this.xhrFile) },
        loadProgress() { return this[GET_AJAXX_CALL_PROGRESS_BY_FILE](this.xhrFile) },
        link() { 
            return this[GET_FILE_BLOB](this.xhrFile) 
        },
        isRolesModelSupported() {
            return this[GET_IS_ROLES_SUPPORTED]
        },
        myContactActions() {
            return this[GET_MY_CONTACT].actions || []
        },
        isWithPreview() {
            return this.message && this.message.msg && this.message.msg.previewFile
        },
        getChatContact() {
            const cid = this[GET_SELECTED_CHAT] && this[GET_SELECTED_CHAT].cid
            if (!cid) return {}
            return this[GET_MERGED_CONTACT_BY_ID](cid)
        },
        getAllowedActions() {
            return this.getChatContact && this.getChatContact.actions || {}
        },
        isSendMediaMessage() {
            if (!this.isRolesModelSupported) return true
            let isAllowed = true
            if (this.myContactActions.hasOwnProperty('send-media-message')) isAllowed = this.myContactActions['send-media-message']
            if (this.cidType === declarations.chatTargetTypes.CHAT_TARGET_TYPE_GROUP) return isAllowed
            if (this.getAllowedActions.hasOwnProperty('send-media-message')) isAllowed = isAllowed && this.getAllowedActions['send-media-message']
            return isAllowed
        },
        ...mapGetters(LOGIN, [GET_SERVER_API]),
        ...mapGetters(AJAX, [GET_AJAXX_CALL_IS_EXIST_BY_FILE, GET_AJAXX_CALL_PROGRESS_BY_FILE]),
        ...mapGetters(BLOB, [GET_FILE_BLOB]),
        ...mapGetters(CHATS, [GET_SELECTED_CHAT]),
        ...mapGetters(CONTACTS, [GET_MY_CONTACT, GET_MERGED_CONTACT_BY_ID, GET_IS_ROLES_SUPPORTED]),
    },
    methods: {
        abortAjaxCall() {
            if (this.xhrId) this[ACT_ABORT_AJAX_CALL](this.xhrId)
        },
        withPreview(type) {
            return ['video', 'image'].includes(type)
        },
        async getPreview(msg, remoteHost = '', index = -1) {
            if (!msg) return
            let preview
            if (remoteHost) {
                preview = `https://${remoteHost}` + '/' + declarations.http_post_dirs.CHAT_DATA_DIR + previewFile
                return preview
            }

            let storedPreview = false
            let previewFile = index > -1 ? msg.groupMsgs[index].previewFile : msg.previewFile
            const previewFilePath = declarations.http_post_dirs.CHAT_DATA_DIR + previewFile
            try {
                storedPreview = await getIDB(previewFilePath) || await getIDB(previewFile)
            } catch (error) {           
                console.log("🚀 ~ file: chat-grouped-message-mixin.js:90 ~ getPreview ~ error:", error)
            }
            const isBlob = storedPreview instanceof Blob
            const isImageBlob = isBlob && (storedPreview.type === "application/image" || storedPreview.type === "application/octet-stream")
            if (storedPreview && isImageBlob) {
                window.URL.revokeObjectURL(storedPreview)
                return window.URL.createObjectURL(storedPreview)
            }
            // if (isBlob && !isImageBlob) delIDB(storedPreview)
            if (previewFile) {
                let preview = this.$store.getters['userdata/getHost'] + '/' + previewFilePath
                if (preview) {
                    const blobFile = await this.getBlobFromURL(preview)
                    if (blobFile) setIDB(previewFilePath, blobFile)
                }
                return preview
            }
            else if (msg.preview) return 'data:image/png;base64,' + msg.preview
        },
        async getGifPreview(msg, remoteHost = '') {
            const storedPreview = await getIDB(msg.file)
            if (storedPreview) {
                window.URL.revokeObjectURL(storedPreview)
                return window.URL.createObjectURL(storedPreview)
            }
            if (msg.previewFile) {
                let preview
                if (remoteHost)  {
                    preview = `https://${remoteHost}` + '/' + declarations.http_post_dirs.CHAT_DATA_DIR + msg.previewFile
                }              
                else preview = this.$store.getters['userdata/getHost'] + '/' + msg.file
                const blobFile = await this.getBlobFromURL(preview)
                setIDB(msg.file, blobFile)
                return preview
            }
        },
        getDownloadFileName(type, name, extension) {
            let filename = name + (extension ? '.' + extension : '')
            let date = moment().format('YYYY-MM-DD_HH-MM-SS')
             if (!name || !filename) filename = (type + '_' + date) + (extension ? '.' + extension : '')
            return filename
        },
        async downloadFile(message, isSaveFile = false) {
            let link = this.$store.getters['blob/getFileBlob'](message.msg.file)
            let fileName = this.getDownloadFileName(message.sub_type, message.msg.name, message.msg.extension)
            fileName = fileName && fileName.replace(/:/g,'_') // fix file name for Windows
            // #if process.env.WEBPACK_BUILD_TARGET === 'web'
            let a = document.createElement('a')
            a.setAttribute('href', link)
            a.setAttribute('download', fileName)
            let evt = document.createEvent('MouseEvents')
            evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            a.dispatchEvent(evt)
            // #endif

            // #if process.env.WEBPACK_BUILD_TARGET === 'electron'
//             let params = {}
//             const uid = message.id + '-' + message.msg.file.match(/(?<=\/data\/).+(?=\.)/)[0] // link && link.replace('blob:file:///', '')
//             let fileKey
//             if (uid) fileKey = 'FilePath:' + uid + fileName
//             else fileKey = 'FilePath:' + fileName
// 
//             
//             let storedPath
//             try {
//                 storedPath = await getIDB(fileKey)
//             } catch {}
//             if (storedPath && !isSaveFile) {
//                 params.fpath = storedPath
//                 try {
//                     let openedFilePath = await ipc.sendAsync('open-file', params)
//                     setIDB(fileKey, openedFilePath)
//                     return true
//                 } catch (e) {
//                     logger.error(e, 'open-file-path error')
//                 }
//             }
//             let fileBlob = await this.getBlobFromURL(link)
//             const reader = new FileReader()
//             reader.onload = async () => {
//                 if (reader.readyState == 2) {
//                     let buffer = Buffer.from(reader.result)
//                     params = { fileName, buffer }
//                     try {
//                         const savedFilePath = await ipc.sendAsync('download-file', params)
//                         if (savedFilePath) {
//                             setIDB(fileKey, savedFilePath)
//                         }
//                     } catch (e) {
//                         logger.error(e, 'download-file error')
//                     }
//                 }
//             }
//             try {
//                 reader.readAsArrayBuffer(fileBlob)
//             } catch (e) {
//                 logger.error(e, 'File read error')
//             }
            // #endif
            this.$store.dispatch(`${DLP}/${ACT_SEND_FILE_SAVE_EVENT}`, {
                fileName:  message.msg.file,
                sourceType: DLP_SOURCE_TYPES.CHAT_MESSAGE,
                sourceData: {
                    id: message.id,
                    cid: message.cid,
                    cidType: message.cidType,
                }
            })
        },
        getSlicedText(dom) {
            let path = [dom.body.childNodes[0]]
            let maxChars = this.maxCharsWithShortMessage
            let chars = 0
            let pop = false
            let full = false
            while (path.length) {
                let node = path[path.length - 1]
                if (!pop && !full) {
                    if (node.nodeType === Node.TEXT_NODE) {
                        let len = node.textContent.length
                        if (chars + len >= maxChars) {
                            if (chars + len !== maxChars) {
                                let sliceVal = node.textContent.slice(0, maxChars - chars)
                                node.textContent = sliceVal
                            }
                            full = true
                        }
                        chars += node.textContent.length
                    } else if (node.classList[0] === 'emoji') {
                        chars += 1
                        if (chars >= maxChars) full = true
                    } else if (node.nodeType === 1) {
                        let childs = node.childNodes
                        let textChildNode = childs[0] && childs[0].nodeType === Node.TEXT_NODE ? childs[0] : null
                        if (textChildNode) {
                            let len = textChildNode.textContent.length
                            if (chars + len >= maxChars) {
                                if (chars + len !== maxChars) {
                                    let sliceVal = textChildNode.textContent.slice(0, maxChars - chars)
                                    textChildNode.textContent = sliceVal
                                }
                                chars += len
                                full = true
                            }
                        }
                        if (chars >= maxChars) full = true
                    }
                }
                if (!pop && node.childNodes.length) {
                    let child = node.childNodes[0]
                    path.push(child)
                } else if (node.nextSibling) {
                    let child = node.nextSibling
                    if (full) {
                        child.remove()
                    } else {
                        path.splice(path.length - 1, 1, child)
                    }
                } else {
                    path.pop()
                    pop = true
                    continue
                }
                pop = false
            }
            return dom.body.innerHTML
        },
        async loadMessageFile (params, cb) {
            let storedFile
            try {
                storedFile = await getIDB(params.file)
            } catch { }
            if (storedFile) {
                const isBlob = storedFile instanceof Blob
                if (!isBlob) storedFile = await this.getBlobFromURL(storedFile)
                window.URL.revokeObjectURL(storedFile)
                const blob_url = window.URL.createObjectURL(storedFile)
                this.$store.commit('blob/updateFileBlob', {
                    file_name: params.file,
                    link: blob_url
                })
                cb && cb()
            } else {
                try {
                    let blobFile = this.$store.getters['blob/getFileBlob'](params.file)
                    if (blobFile) cb && cb()
                    storedFile = await this[ACT_AJAX_GET_FILE]({ url: params.file, remoteHost: params.remoteHost, fileSize: params.size, encKey: params.key, link: true })
                    setIDB(params.file, storedFile)
                    cb && cb()
                } catch (e) {
                    logger.info('get file error')
                }
            }
        },
        async getBlobFromURL(url) {
            try {
                let objParams = {}
                if (this.isAjaxCookiesSupported) objParams = { credentials: "include" }
                let fetchRes = await fetch(url, objParams)
                if (fetchRes && fetchRes.ok) return await fetchRes.blob()
                return null
            } catch (error) {
                console.log("🚀 ~ chat-message-mixin.js:336 ~ getBlobFromURL ~ error:", error)
                return null
            }
        },
        _getFio(cid) {
            return ( this.$store.getters["contacts/getMergedContactById"](cid).fio || "" )
        },         
        _getItemText(message) {
            let text = ''
            switch (message.dataType) {
                case declarations.msgDataTypes.MSG_DATA_TYPE_TEXT:
                    text = message.data
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_DATA:
                    text = this._getDataText(message.data)
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_UNSTORED:
                    text = message.data
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_SYSTEM:
                    text = ""
                    break
                default:
                    text = ""
            }
            return text
        },         
        _getDateTime(details) {
            return (details.sentDate + ' ' + details.sentTime) || ''
        },
        _getDataTypeName(type) {
            switch (type) {
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
                    return this.$t('image')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                    return this.$t('video')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
                    return this.$t('file')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                    return this.$t('audio')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
                    return this.$t('contact')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
                    return this.$t('mainPage.location')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
                    return this.$t('channel')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
                    return this.$t('publication')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
                    return this.$t('poll')
                default:
                    return false
            }        
        },        
        _getDataText(data) {
            let text = ''
            switch (data.type) {
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
                    const fields = Array.isArray(data.fields) && data.fields
                    const phones = fields && fields.filter(f => f.type === "phone" || f.type === "workphone")
                    const phone = phones && phones.length && phones[0].value
                    const mails = fields && fields.filter(f => f.type === "mail")
                    const mail = mails && mails.length && mails[0].value
                    const fio = (fields && fields.fio) || phone || mail
                    text = fio
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
                    text = data.text
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
                    return ''
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
                    text = data.longitude + " " + data.latitude
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:                
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
                    text = data && data.hasOwnProperty("text") ? data.text : '' || ''
                    break
                // case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                // case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                // case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
                //     text = data && data.hasOwnProperty("name") ? data.name + '.' + data.extension + ' ' : data.extension || '' + '\n'
                //     break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
                    text = data.topic
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT:
                    text = data.text
                    break
                default:
                    text = ""
            }
            return text
        },
        ...mapActions(AJAX, [ACT_AJAX_GET_FILE, ACT_ABORT_AJAX_CALL])
    }

}

export default mixin